import { useState } from "react";
import CategoryCard from "./Cards/CategoryCard";
import ProductCardStyleOne from "./Cards/ProductCardStyleOne";
import DataIteration from "./DataIteration";
import ViewMoreTitle from "./ViewMoreTitle";
import LoaderStyleOne from "./Loaders/LoaderStyleOne";

export default function SectionStyleOne({
  className,
  categoryTitle,
  sectionTitle,
  seeMoreUrl,
  brands = [],
  products = [],
  categoryBackground,
  loadMore,
  loading,
  totalProducts,
  viewMore,
  openStoreList
}) {
  return (
    <div data-aos="fade-up" className={`section-style-one ${className || ""}`}>
      <ViewMoreTitle categoryTitle={sectionTitle} seeMoreUrl={seeMoreUrl}>
        <div className="products-section w-full">
          <div className="grid xl:grid-cols-6 lg:grid-cols-6 sm:grid-cols-3 grid-cols-2 xl:gap-[10px] gap-2">
            {/* <div className="category-card hidden xl:block w-full">
              <CategoryCard
                background={categoryBackground}
                title={categoryTitle}
                brands={filterBrands}
              />
            </div> */}
            {products?.map((item, index) => (
              <div key={index} className="item">
                <ProductCardStyleOne datas={item} openStoreList={openStoreList} />
              </div>
            ))}
            {/* <DataIteration
              datas={products}
              startLength={0}
              endLength={productLength}
            >
              {({ datas }) => (
                <div key={datas.id} className="item">
                  <ProductCardStyleOne datas={datas} />
                </div>
              )}
            </DataIteration> */}
          </div>
        </div>
      </ViewMoreTitle>
      {viewMore &&
        <>
          {products.length !== totalProducts &&
            <div className="flex-1 flex justify-center mt-6 h-full">
              <button
                type="button"
                onClick={() => loadMore()}
                className="text-md bg-qblue font-semibold text-white w-[180px] h-[45px] flex justify-center items-center"
              >
                <span>
                  Load More
                </span>
                {loading && (
                  <span className="w-3 " style={{ transform: "scale(0.3)" }}>
                    <LoaderStyleOne />
                  </span>
                )}
              </button>
            </div>
          }
        </>
      }
    </div>
  );
}
